var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.32,
    height: 60.29,
    viewBox: "0 0 56.32 60.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.87,60.29H4.15c-2.29,0-4.15-1.86-4.15-4.15v-22.97c0-2.29,1.86-4.15,4.15-4.15h41.72c2.29,0,4.15,1.86,4.15,4.15v22.97c0,2.29-1.86,4.15-4.15,4.15ZM4.15,30.53c-1.46,0-2.65,1.19-2.65,2.65v22.97c0,1.46,1.19,2.65,2.65,2.65h41.72c1.46,0,2.65-1.19,2.65-2.65v-22.97c0-1.46-1.19-2.65-2.65-2.65H4.15Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.58,53.21h-3.31c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h3.31c1.24,0,2.24-1,2.24-2.24v-9.61c0-1.24-1-2.24-2.24-2.24h-3.31c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h3.31c2.06,0,3.74,1.68,3.74,3.74v9.61c0,2.06-1.68,3.74-3.74,3.74Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.15,55.67H6.85c-.41,0-.75-.34-.75-.75v-20.53c0-.41.34-.75.75-.75h8.3c.41,0,.75.34.75.75v20.53c0,.41-.34.75-.75.75Zm-7.55-1.5h6.8v-19.03h-6.8v19.03Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.16,55.67h-8.3c-.41,0-.75-.34-.75-.75v-20.53c0-.41.34-.75.75-.75h8.3c.41,0,.75.34.75.75v20.53c0,.41-.34.75-.75.75Zm-7.55-1.5h6.8v-19.03h-6.8v19.03Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.17,55.68h-8.3c-.41,0-.75-.34-.75-.75v-20.53c0-.41.34-.75.75-.75h8.3c.41,0,.75.34.75.75v20.53c0,.41-.34.75-.75.75Zm-7.55-1.5h6.8v-19.03h-6.8v19.03Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.44,30.53c-.26,0-.51-.14-.65-.38-1.02-1.78-1.56-3.81-1.56-5.86,0-6.5,5.28-11.78,11.78-11.78s11.78,5.28,11.78,11.78c0,2.06-.54,4.09-1.56,5.86-.21.36-.66.48-1.02.28-.36-.21-.48-.67-.28-1.02.89-1.55,1.36-3.32,1.36-5.12,0-5.67-4.61-10.28-10.28-10.28s-10.28,4.61-10.28,10.28c0,1.8.47,3.57,1.36,5.12.21.36.08.82-.28,1.02-.12.07-.25.1-.37.1Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.81,30.53c-.12,0-.25-.03-.37-.1-.36-.2-.49-.66-.29-1.02,1.11-1.98,2.77-3.58,4.81-4.64l.94-.48-.94-.48c-5.11-2.64-7.55-8.53-5.79-14l.32-1.01-1,.32c-5.48,1.75-11.36-.69-14-5.8l-.48-.94-.48.94c-2.64,5.11-8.52,7.55-14,5.8l-1.01-.32.32,1c1.75,5.49-.69,11.37-5.8,14l-.95.49.95.49c2.05,1.05,3.71,2.66,4.82,4.64.2.36.07.82-.29,1.02-.36.2-.82.07-1.02-.29-.96-1.72-2.41-3.12-4.2-4.04l-2.24-1.16c-.25-.13-.41-.39-.41-.67s.16-.54.41-.67l2.24-1.15c4.46-2.29,6.58-7.42,5.06-12.21l-.77-2.39c-.09-.27-.02-.56.18-.76.2-.2.49-.27.76-.18l2.4.77c4.77,1.53,9.91-.6,12.2-5.06l1.15-2.23c.13-.25.39-.41.67-.41h0c.28,0,.54.16.67.41l1.15,2.23c2.3,4.45,7.43,6.58,12.21,5.06l2.39-.77c.27-.09.56-.02.76.18.2.2.27.49.19.76l-.76,2.4c-1.53,4.77.59,9.9,5.05,12.21l2.24,1.15c.25.13.41.39.41.67s-.16.54-.41.67l-2.24,1.15c-1.77.92-3.22,2.31-4.19,4.04-.14.25-.39.38-.66.38Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.73ecac5d40531e0146f68db3a6825bc3.svg";
export { ForwardRef as ReactComponent };